import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Alert,
  Form,
  Input,
  Button,
  FormFeedback,
  Label,
  InputGroup,
} from "reactstrap";
import { connect } from "react-redux";
import { Link, withRouter, Redirect, useLocation } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import * as Auth from "../../helpers/authUtils";
//Import Components
import LanguageSelector from "../../components/LanguageSelector";
import ThemeSwitcher from "../../components/ThemeSwitcher";
import Spinner from "../../components/ButtonSpinner";

//i18n
import { useTranslation } from "react-i18next";

//redux store
import { loginUser, apiError } from "../../redux/actions";

//Import Images
import logodark from "../../assets/images/logo-dark.png";
import logolight from "../../assets/images/logo-light.png";

/**
 * Login component
 * @param {*} props
 */

const Login = (props) => {
  /* intilize t variable for multi language implementation */
  const { t } = useTranslation();
  const [isLoading, setLoading] = useState(false);
  const search = useLocation().search;
  const redirect = new URLSearchParams(search).get("redirect");

  useEffect(() => {
    // props.apiError("");
    if (props.error) {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  }, [props.error]);

  useEffect(() => {
    if (localStorage.token) {
      // Safe if the saga already sent: doVerification no-ops when the flag is set.
      Auth.doVerification();
    }
    let affiliate = getQueryVariable("affiliate");
    if (!affiliate) {
      const match = document.cookie.match(
        /(?:^|; )atchr_affiliate=([^;]*)/
      );
      affiliate = match ? decodeURIComponent(match[1]) : "";
    }
    if (affiliate) {
      localStorage.setItem("affiliate", affiliate);
    }
  }, []);

  // validation
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please enter your email"),
      password: Yup.string()
        .min(8, "Please enter a valid password")
        .required("Please enter your password"),
    }),
    onSubmit: (form) => {
      if (isLoading) {
        return;
      }
      setLoading(true);
      props.loginUser(form.email, form.password, props.history);
    },
  });

  const routeChange = (path = null) => {
    window.location.href = path || "/";
  };

  const getQueryVariable = (variable) => {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (decodeURIComponent(pair[0]) == variable) {
        return decodeURIComponent(pair[1]);
      }
    }
  };

  if (localStorage.getItem("token")) {
    // Auth.doVerification();
    if (redirect) {
      return <Redirect to={`/verify/?redirect=${redirect}`} />;
    }
    return <Redirect to="/verify" />;
  }

  return (
    <React.Fragment>
      <div className="account-pages mt-5 pt-sm-5 pt-md-0">
        <div className="faux-menu">
          <ThemeSwitcher />
          <LanguageSelector />
        </div>
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <div className="text-center mb-4">
                <Link
                  to="/"
                  onClick={() => routeChange("/")}
                  className="auth-logo mb-2 d-block"
                >
                  <img
                    src={logodark}
                    alt={process.env.REACT_APP}
                    height="50"
                    className="logo logo-dark"
                  />
                  <img
                    src={logolight}
                    alt={process.env.REACT_APP}
                    height="50"
                    className="logo logo-light"
                  />
                </Link>

                <h4>{t("Sign in")}</h4>
                <p className="text-muted mb-4">
                  {t("Sign in to continue to Atchr.")}
                </p>
              </div>

              <Card>
                <CardBody className="p-4">
                  {props.error && (
                    <Alert className="mb-0" color="danger">
                      {props.error}
                    </Alert>
                  )}
                  <div className="p-3">
                    <Form onSubmit={formik.handleSubmit}>
                      <div className="mb-3">
                        <Label className="form-label">{t("Email")}</Label>
                        <InputGroup className="mb-3 rounded-3">
                          <span
                            className="input-group-text text-muted"
                            id="basic-addon3"
                          >
                            <i className="ri-user-2-line"></i>
                          </span>
                          <Input
                            type="email"
                            id="email"
                            name="email"
                            className="form-control form-control-lg border-light bg-soft-light"
                            placeholder="Enter email"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.email}
                            invalid={
                              formik.touched.email && formik.errors.email
                                ? true
                                : false
                            }
                          />
                          {formik.touched.email && formik.errors.email ? (
                            <FormFeedback type="invalid">
                              {formik.errors.email}
                            </FormFeedback>
                          ) : null}
                        </InputGroup>
                      </div>

                      <FormGroup className="mb-4">
                        <div className="float-end">
                          <Link to="help" className="text-muted font-size-13">
                            {t("Forgot your password")}?
                          </Link>
                        </div>
                        <Label className="form-label">{t("Password")}</Label>
                        <InputGroup className="mb-3 rounded-3">
                          <span className="input-group-text text-muted">
                            <i className="ri-lock-2-line"></i>
                          </span>
                          <Input
                            type="password"
                            id="password"
                            name="password"
                            className="form-control form-control-lg border-light bg-soft-light"
                            placeholder="Enter Password"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.password}
                            invalid={
                              formik.touched.password && formik.errors.password
                                ? true
                                : false
                            }
                          />
                          {formik.touched.password && formik.errors.password ? (
                            <FormFeedback type="invalid">
                              {formik.errors.password}
                            </FormFeedback>
                          ) : null}
                        </InputGroup>
                      </FormGroup>

                      <div className="form-check mb-4">
                        <Input
                          type="checkbox"
                          className="form-check-input"
                          id="remember-check"
                        />
                        <Label
                          className="form-check-label"
                          htmlFor="remember-check"
                        >
                          {t("Remember me")}
                        </Label>
                      </div>

                      <div className="d-grid">
                        <Button
                          color="primary"
                          className={
                            isLoading
                              ? "btn-loading waves-effect waves-light"
                              : "waves-effect waves-light"
                          }
                          type="submit"
                          disabled={isLoading}
                        >
                          {isLoading ? <Spinner /> : t("Sign in")}
                        </Button>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>

              <div className="mt-5 text-center">
                <p>
                  {t("Don't have an account")}?{" "}
                  <Link
                    to="register"
                    className="font-weight-medium text-primary"
                  >
                    {" "}
                    {t("Signup now")}{" "}
                  </Link>{" "}
                </p>
                <p>
                  &copy;{props.currentYear} {t("Atchr")} {t("by Chromesque")}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { user, loading, error } = state.Auth;
  const { currentYear } = state.Misc;
  return { user, loading, error, currentYear };
};

export default withRouter(
  connect(mapStateToProps, { loginUser, apiError })(Login)
);
